
import { Box, Grid, Typography } from '@mui/material'

const PromotionView = () => {
  return (
    <Grid
      sx={{
        paddingTop: 3,
        paddingBottom: 5,
      }}
      container>
      <Grid item xs={12} sm={12} md={12} lg={6}>
        <Grid container spacing={3}>
          <Grid
            sx= {{
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
            }}
            item xs={12}>
            <Typography
              sx={{
                color: '#FFF',
                width: 400,
              }}
              variant="h4">
              Thank you
            </Typography>
          </Grid>
          <Grid
            sx= {{
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
            }}
            item xs={12}>
            <Typography
              sx={{
                color: '#FFF',
                width: 400,
              }}
              variant="body1">
              You have successfully registered your interest in TFM’s FBT Reporting. One of our team members will be in contact to discuss this with you.<br /><br />
              If you have any questions feel free to contact us at fleet.operations@tfs.co.nz<br /><br />
              Toyota Fleet Management
            </Typography>
          </Grid>
        </Grid>

      </Grid>

      <Grid
        sx= {{
          textAlign: 'center',
          display: 'flex',
          justifyContent: 'center',
        }}
        item xs={12} sm={12} md={12} lg={6}>
        <Box
          component="img"
          src="p/static/images/marketing/dashboard-app-promo.png"
          alt="car"
          sx={{
            width: 400,
            height: 'auto',
            margingTop: { sm: 3 },
            '@media (max-width:600px)': {
              width: 350,
              marginTop: 0
            },
            '@media (max-width:0px)': {
              width: 250,
              marginTop: 0
            },
          }}/>
      </Grid>
    </Grid>
  )
}

export default PromotionView
